import Vue from 'vue'

const client = () => Vue.prototype.$api

export default {
  isFirstAppointment (profId) {
    return client().get('appointments/isFirstAppointment', {profId: profId})
  },
  getAppointmentReport (appointmentId) {
    return client().get('/patientReportPDF', {params: {appointmentId: appointmentId}})
  },
  getAppointmentPrescription (appointmentId) {
    return client().get(`/prescriptions/${appointmentId}`, { responseType: 'blob' })
  },
  getNextPatientAppointments (hideLoadingIcon) {
    return client().get('/patients/appointments/next', { loading: !hideLoadingIcon })
  },
  getPastPatientAppointments ({fromDate, toDate, professionalName, appointmentType}) {
      return client().get('/patients/appointments/past', {params: {fromDate: fromDate, toDate: toDate, professionalName: professionalName, appointmentType: appointmentType}})
  },
  getAppointmentDetails (appointmentId){
    return client().get('appointments/Chats/GetAppointmentDetails', { params: {appointmentId: appointmentId} })
  },
  cancelAppointment (appointmentId, reason) {
    return client().post('PatientCancelationAppointment', { AppointmentId: appointmentId, Reason: reason })
  }
}


// WEBPACK FOOTER //
// ./src/repositories/AppointmentsRepository.js